<div class="admin-component-container">
    <dish-admin-nav-bar></dish-admin-nav-bar>
    <div class="router-outlet-container">
        <ng-content></ng-content>
    </div>
    <dish-admin-footer></dish-admin-footer>
</div>
